import { render, staticRenderFns } from "./dispalyRules.vue?vue&type=template&id=1ce0b48a&"
import script from "./dispalyRules.vue?vue&type=script&lang=ts&"
export * from "./dispalyRules.vue?vue&type=script&lang=ts&"
import style0 from "./dispalyRules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports